module.exports = __webpack_public_path__ + "img/rent.aae0b567.jpeg";